import { match as clientId } from "../../../src/params/clientId.js";
import { match as id } from "../../../src/params/id.js";
import { match as uid } from "../../../src/params/uid.js";
import { match as uuid } from "../../../src/params/uuid.js";

export const matchers = { clientId, id, uid, uuid };